import {
  IndexNavAll,
  IndexNavBrands,
  IndexNavCountries,
  IndexNavNew,
} from '@/components/home/Index/IndexNav/IndexNavs';
import { Routes } from '@/types/routes.enum';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { IndexV2Enum } from '@/types/translations/IndexV2Enum';
import DefaultLink from '@/components/common/default/DefaultLink';
import { createSearchUrl } from '@/utilites/algolia/create-algolia-urls';
import { IndexNavProps } from '@/types';

export default function IndexNav({ newSkus, newCollections }: IndexNavProps) {
  const { translate } = useTypedTranslation<IndexV2Enum>('index-v2');
  return (
    <div className="tw-mb-8 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-4 tw-px-2">
      {/* always visible */}
      <IndexNavAll />

      {/* sm+ */}
      <div>
        <IndexNavBrands />
      </div>
      <div>
        <IndexNavNew newSkus={newSkus} newCollections={newCollections} />
      </div>
      {/* lg+ */}
      <div className="tw-hidden sm:tw-block">
        <IndexNavCountries />
      </div>
      <div>
        <DefaultLink
          className="tw-mx-0 tw-my-0 tw-appearance-none tw-border-none tw-bg-transparent tw-px-0 tw-py-0 tw-text-base tw-font-medium tw-text-textBlack tw-shadow-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 max-nine:tw-text-xs-custom nine:tw-max-w-xs"
          href={Routes._COLLECTIONS}
        >
          {translate(IndexV2Enum['home_nav.collections'])}
        </DefaultLink>
      </div>
      <div>
        <DefaultLink
          className="tw-mx-0 tw-my-0 tw-appearance-none tw-border-none tw-bg-transparent tw-px-0 tw-py-0 tw-text-base tw-font-medium tw-text-textBlack tw-shadow-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 max-nine:tw-text-xs-custom nine:tw-max-w-xs"
          href={createSearchUrl('limited edition')}
        >
          {translate(IndexV2Enum['home_nav.limited_edition'])}
        </DefaultLink>
      </div>
      <div className="tw-hidden sm:tw-block">
        <DefaultLink
          className="tw-mx-0 tw-my-0 tw-appearance-none tw-border-none tw-bg-transparent tw-px-0 tw-py-0 tw-text-base tw-font-medium tw-text-textBlack tw-shadow-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 max-nine:tw-text-xs-custom nine:tw-max-w-xs"
          href={createSearchUrl('old and rare')}
        >
          {translate(IndexV2Enum['home_nav.old_and_rare'])}
        </DefaultLink>
      </div>

      {/* md+ */}
      <div className="tw-hidden md:tw-block">
        <DefaultLink
          className="tw-mx-0 tw-my-0 tw-appearance-none tw-border-none tw-bg-transparent tw-px-0 tw-py-0 tw-text-base tw-font-medium tw-text-textBlack tw-shadow-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 max-nine:tw-text-xs-custom nine:tw-max-w-xs"
          href={Routes._BLOG}
        >
          {translate(IndexV2Enum['home_nav.magazine'])}
        </DefaultLink>
      </div>
      <div className="tw-hidden md:tw-block">
        <DefaultLink
          className="tw-mx-0 tw-my-0 tw-appearance-none tw-border-none tw-bg-transparent tw-px-0 tw-py-0 tw-text-base tw-font-medium tw-text-textBlack tw-shadow-none tw-outline-none focus:tw-outline-none focus:tw-ring-0 max-nine:tw-text-xs-custom nine:tw-max-w-xs"
          href={Routes._HELP}
        >
          {translate(IndexV2Enum['home_nav.faq'])}
        </DefaultLink>
      </div>
    </div>
  );
}
